<div
  style="
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    background: #000000;
  "
>
  <div
    style="
      display: flex;
      flex-direction: column;
      gap: var(--iframe-gap);
      align-items: center;
      background: var(--iframe-modal-bg);
      border-radius: 20px;
      padding: 20px;
      max-width: 320px;
      width: calc(100% - 40px);
      max-height: 90vh;
      overflow-y: auto;
    "
  >
    <div style="display: flex; align-items: center; gap: 0; justify-content: center">
      <!-- 10px overlap -->
      <div style="width: 38px; height: 48px; z-index: 10; overflow: visible">
        {{#if userAvatar}}
        <img
          src="{{userAvatar}}"
          alt="{{userName}}"
          style="width: 48px; height: 48px; border-radius: 24px; object-fit: cover"
        />
        {{else}}
        <span
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            border-radius: 24px;
            background-color: var(--iframe-button-bg);
            color: var(--iframe-button-text);
            font-size: 14px;
            font-weight: 600;
          "
          >U</span
        >
        {{/if}}
      </div>

      <!-- ------------------------------------------------------------ -->

      <div style="width: 38px; height: 48px; z-index: 5; overflow: visible">
        {{#if displayLogo}}
        <img
          src="{{displayLogo}}"
          alt="{{displayName}}"
          style="width: 48px; height: 48px; border-radius: 24px; object-fit: cover"
        />
        {{else}}
        <span
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            border-radius: 24px;
            background-color: var(--iframe-button-bg);
            color: var(--iframe-button-text);
            font-size: 14px;
            font-weight: 600;
          "
          >A</span
        >
        {{/if}}
      </div>
    </div>

    <div style="display: flex; align-items: center; gap: var(--iframe-gap); justify-content: center">
      <span
        style="
          width: fit-content;
          font-size: var(--iframe-h2-fz);
          font-weight: var(--iframe-heading-fw);
          line-height: 150%;
          text-align: center;
        "
        >{{displayName}}</span
      >
    </div>

    <div class="domain-info {{domainStatusClass}}">
      <span style="display: block; width: 100%; font-size: 12px; text-align: center; font-family: monospace"
        >{{domainStatusIcon}} {{origin}}</span
      >
    </div>

    <!-- Permissions box -->
    <div
      id="data-auth-permissions-block"
      aria-expanded="false"
      style="display: flex; flex-direction: column; width: 100%"
    >
      <div
        id="data-auth-permissions-toggler"
        style="
          cursor: pointer;
          text-align: center;
          list-style: none;
          padding: 0 var(--iframe-pd);
          user-select: none;
          font-size: 12px;
          line-height: 20px;
        "
      >
        Show Permissions ▼
      </div>

      <div
        id="data-auth-permissions-content"
        style="width: 100%; height: var(--iframe-permissions-h, 0); overflow: hidden; transition: height 300ms ease"
      >
        <div
          style="
            width: 100%;
            padding: var(--iframe-gap);
            border-radius: var(--iframe-el-bdrs);
            background: var(--iframe-info);
            font-size: 10px;
          "
        >
          <div style="margin-bottom: var(--iframe-gap)">
            <strong>{{displayName}}</strong> by <span class="project-owner">{{displayName}}</span> wants to access your
            <strong>embarkAI</strong> account
          </div>

          <div style="margin-bottom: var(--iframe-gap)">
            <strong style="margin-bottom: var(--iframe-gap)">Personal user data</strong>
            <ul style="list-style: none">
              <li style="padding-left: var(--iframe-pd)">Wallet address (read-only)</li>
              <li style="padding-left: var(--iframe-pd)">Public transaction history (read-only)</li>
            </ul>
          </div>

          <div style="width: 100%">
            <strong style="margin-bottom: var(--iframe-gap)">Permissions</strong>
            <ul style="list-style: none">
              <li style="padding-left: var(--iframe-pd)">Request transaction signatures</li>
              <li style="padding-left: var(--iframe-pd)">Initiate blockchain operations</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    {{#if showSecurityWarning}}
    <div class="security-warning">
      <strong>⚠️ Warning:</strong> This domain is not verified for {{displayName}}
      <div>Expected: {{expectedDomains}}</div>
      <div>Actual: {{origin}}</div>
    </div>
    {{else}}
    <span style="display: block; text-align: center; font-size: 10px; color: var(--iframe-text-secondary)"
      >By continuing you allow the app to use these permissions, you can revoke access at any time.</span
    >
    {{/if}}

    <!-- Action buttons -->
    <div style="display: flex; gap: var(--iframe-gap); width: 100%; align-items: center">
      <button class="cancel-btn">Cancel</button>
      <button class="authorize-btn" {{authorizeButtonState}}>Continue</button>
    </div>
  </div>
</div>
